export const PINGPONG_ACCESS_TOKEN_KEY = 'PINGPONG_ACCESS_TOKEN'
export const AUTH_SESSION_INVALID_EVENT = 'pingpong-auth-session-invalid'

let memoryAccessToken: string | null = null

export function readAccessToken(): string | null {
  if (memoryAccessToken) return memoryAccessToken
  if (typeof window === 'undefined') return null

  try {
    const stored = window.sessionStorage.getItem(PINGPONG_ACCESS_TOKEN_KEY)
    memoryAccessToken = stored?.trim() || null
  } catch {
    // Storage can be blocked. Authentication still works in memory for this page.
  }

  return memoryAccessToken
}

export function writeAccessToken(accessToken: string): void {
  const normalized = accessToken.trim()
  memoryAccessToken = normalized || null

  if (typeof window === 'undefined') return

  try {
    if (normalized) {
      window.sessionStorage.setItem(PINGPONG_ACCESS_TOKEN_KEY, normalized)
    } else {
      window.sessionStorage.removeItem(PINGPONG_ACCESS_TOKEN_KEY)
    }
  } catch {
    // The in-memory copy keeps the current page usable when storage is blocked.
  }
}

export function clearAccessToken(): void {
  memoryAccessToken = null
  if (typeof window === 'undefined') return

  try {
    window.sessionStorage.removeItem(PINGPONG_ACCESS_TOKEN_KEY)
  } catch {
    // The in-memory token has already been discarded.
  }
}

export function notifyInvalidAuthSession(): void {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new Event(AUTH_SESSION_INVALID_EVENT))
}
